import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface ResumeSessionProps {
  isOpen: boolean;
  onClose: () => void;
  onResume?: () => void;
  onRestart?: () => void;
}

/**
 * M4 — «Продолжить или начать заново».
 * Показывается, если найдена незавершённая сессия (см. UX-спека v1.2, раздел восстановления).
 * В Фазе 1 — реальный UI без логики.
 */
export function ResumeSession({ isOpen, onClose, onResume, onRestart }: ResumeSessionProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Продолжить тест?">
      <div className="flex flex-col gap-4 text-sm text-text-primary">
        <p>Вы начали тест ранее. Продолжить с того места, где остановились, или начать заново?</p>
        <div className="flex flex-col gap-2 pt-2">
          <Button onClick={onResume ?? onClose} fullWidth>
            Продолжить
          </Button>
          <Button onClick={onRestart ?? onClose} fullWidth variant="secondary">
            Начать заново
          </Button>
          <Button onClick={onClose} fullWidth variant="ghost" size="md">
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
}
